import ParameterizedTextInput from 'shared/components/molecules/ParameterizedTextInput/ParameterizedTextInput';

export default ParameterizedTextInput;
